/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_error__500__text_end = /** @type {(inputs: {}) => string} */ () => {
	return `für Hilfe.`
};

const en_error__500__text_end = /** @type {(inputs: {}) => string} */ () => {
	return `for assistance.`
};

const es_error__500__text_end = /** @type {(inputs: {}) => string} */ () => {
	return `por ayuda.`
};

const fr_error__500__text_end = /** @type {(inputs: {}) => string} */ () => {
	return `pour obtenir de l’aide.`
};

const it_error__500__text_end = /** @type {(inputs: {}) => string} */ () => {
	return `chiedere assistenza.`
};

const nl_error__500__text_end = /** @type {(inputs: {}) => string} */ () => {
	return `voor hulp.`
};

const pt_error__500__text_end = /** @type {(inputs: {}) => string} */ () => {
	return `para assistência.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const error__500__text_end = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.error__500__text_end(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("error__500__text_end", locale)
	if (locale === "de") return de_error__500__text_end(inputs)
	if (locale === "en") return en_error__500__text_end(inputs)
	if (locale === "es") return es_error__500__text_end(inputs)
	if (locale === "fr") return fr_error__500__text_end(inputs)
	if (locale === "it") return it_error__500__text_end(inputs)
	if (locale === "nl") return nl_error__500__text_end(inputs)
	return pt_error__500__text_end(inputs)
};